import CustomPrintConfiguratorPhotoSelectorModal from './CustomPrintConfiguratorPhotoSelectorModal';

export default CustomPrintConfiguratorPhotoSelectorModal;
